import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteCartonPropertyGroup } from "@/api/carton-property-group-api";

import { CARTON_PROPERTY_GROUPS_QUERY_KEY } from "./use-carton-property-group";

export const useDeleteCartonPropertyGroup = (cartonPropertyGroupId: string | undefined) => {
	const queryClient = useQueryClient();

	return useMutation<void, Error, void>(
		{
			mutationFn: async () => {
				if (!cartonPropertyGroupId) {
					throw new Error("Carton Property Group ID is required");
				}

				await deleteCartonPropertyGroup(cartonPropertyGroupId);

				await queryClient.refetchQueries({ queryKey: [CARTON_PROPERTY_GROUPS_QUERY_KEY] });
			},
		},
		queryClient,
	);
};
